import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Components
import MainContainer from "components/layout/MainContainer";

// Data
import { routes } from "utils/constants";
import "./index.css";

function App() {
  const router = createBrowserRouter(routes);

  return (
    <MainContainer>
      <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
    </MainContainer>
  );
}

export default App;
